import styled from '@emotion/styled'
import colors from '../colors'

export const Panel = styled.div`
	background-color: ${colors.white};
	border-radius: 10px;
`

export default Panel
